import {gql} from "@apollo/client";

export const GET_USER_REGULATOR_REGISTRATION = gql`
          query GetUserRegulatorRegistration {
                userRegulatorRegistration {
                    playerState,
                    permissionGrade
                }
              }
          `;